import type { Indexable } from "../Indexable.js";
import { Locale, type LocalizedString } from "../Locale.js";
import type { IndexableTable } from "../indexableTables.js";
import { newsKindNameMap } from "./newsKindNameMap.js";

export function getIndexableName<T extends IndexableTable>(indexable: Indexable<T>): LocalizedString {
	switch (indexable._tags[0]) {
		case "company": {
			return { [Locale.cs]: "Klient" };
		}
		case "product_category": {
			return { [Locale.cs]: "Kategorie" };
		}
		case "news": {
			return newsKindNameMap[(indexable as Indexable<"news">)._data.kind];
		}
		case "product": {
			return { [Locale.cs]: "Produkt" };
		}
		case "solution": {
			return { [Locale.cs]: "Řešení" };
		}
	}
	throw new Error("Unknown indexable");
}
